var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.73555,
    cy: 6.27803,
    r: 4.77803,
    stroke: "url(#paint0_linear_216_994)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.15675 17.7014C1.15547 17.3655 1.23059 17.0338 1.37643 16.7312C1.8341 15.8158 3.12472 15.3307 4.19566 15.111C4.96802 14.9462 5.75104 14.8361 6.53891 14.7815C7.99758 14.6534 9.46467 14.6534 10.9233 14.7815C11.7111 14.8367 12.4941 14.9468 13.2666 15.111C14.3375 15.3307 15.6282 15.7701 16.0858 16.7312C16.3791 17.348 16.3791 18.064 16.0858 18.6808C15.6282 19.6419 14.3375 20.0813 13.2666 20.2918C12.4951 20.4635 11.7118 20.5767 10.9233 20.6305C9.73611 20.7311 8.54332 20.7495 7.35355 20.6854C7.07895 20.6854 6.81351 20.6854 6.53891 20.6305C5.75337 20.5773 4.97306 20.4641 4.20481 20.2918C3.12472 20.0813 1.84325 19.6419 1.37643 18.6808C1.23134 18.3747 1.15629 18.0402 1.15675 17.7014Z",
    stroke: "url(#paint1_linear_216_994)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_216_994",
    x1: 15.6066,
    y1: -5.76437,
    x2: 21.0713,
    y2: 2.35908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26468B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_216_994",
    x1: 19.6238,
    y1: 10.0959,
    x2: 21.4884,
    y2: 17.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26468B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26468B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.eae0f1e02572d75c5eaf7008e7d76a76.svg";
export { ForwardRef as ReactComponent };